var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

export default createHasSubmitFailed;


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/hasSubmitFailed.js
// module id = 1186
// module chunks = 0